// DEPLOY: /var/www/woody.wtf/frontend/src/chart/IndicatorPicker.js
// Searchable indicator list: the user's favourites (Settings page) first, then
// "On price" and "Own pane". Desktop: dialog. Phone: slide-up sheet.
import React, { useState, useEffect, useRef } from 'react';
import { INDICATORS } from './indicators';

const S = {
  overlay: { position: 'fixed', inset: 0, background: 'var(--overlay)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '10vh' },
  box:     { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'calc(var(--radius) * 2)', boxShadow: '0 8px 32px rgba(0,0,0,0.2)', width: '420px', maxWidth: '94vw', maxHeight: '70vh', display: 'flex', flexDirection: 'column' },
  sheet:   { position: 'fixed', left: 0, right: 0, bottom: 0, maxHeight: '75vh', background: 'var(--surface)', borderRadius: '14px 14px 0 0', boxShadow: '0 -4px 24px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column', zIndex: 1001 },
  head:    { padding: '12px 14px 8px', borderBottom: '1px solid var(--border)' },
  search:  { width: '100%', padding: '8px 10px', fontSize: '14px', border: '1px solid var(--border)', borderRadius: 'var(--radius)', background: 'var(--bg)', color: 'var(--text)', boxSizing: 'border-box', outline: 'none' },
  list:    { overflowY: 'auto', padding: '4px 6px 12px' },
  group:   { fontSize: '10px', fontWeight: 700, color: 'var(--text-muted)', fontFamily: "'JetBrains Mono',monospace", textTransform: 'uppercase', letterSpacing: '0.06em', padding: '10px 8px 4px' },
  item:    { display: 'flex', alignItems: 'baseline', gap: '10px', width: '100%', padding: '8px', border: 'none', background: 'none', borderRadius: '6px', cursor: 'pointer', textAlign: 'left', color: 'var(--text)', fontSize: '13px' },
  short:   { fontFamily: "'JetBrains Mono',monospace", fontSize: '11px', color: 'var(--text-muted)', minWidth: '62px' },
};

export default function IndicatorPicker({ mobile, favourites = [], onPick, onClose }) {
  const [q, setQ] = useState('');
  const ref = useRef(null);
  useEffect(() => { if (!mobile) ref.current?.focus(); }, [mobile]);
  const match = ([, d]) => !q || `${d.name} ${d.short}`.toLowerCase().includes(q.toLowerCase());
  const all = Object.entries(INDICATORS).filter(match);
  const groups = [
    ['Favourites', all.filter(([id]) => favourites.includes(id))],
    ['On price', all.filter(([, d]) => d.pane === 'price')],
    ['Own pane', all.filter(([, d]) => d.pane === 'own')],
  ].filter(([, items]) => items.length);

  const body = (
    <div style={mobile ? S.sheet : S.box} onPointerDown={e => e.stopPropagation()}>
      <div style={S.head}>
        <input ref={ref} style={S.search} placeholder="Search indicators" value={q} onChange={e => setQ(e.target.value)}
               onKeyDown={e => e.key === 'Escape' && onClose()} />
      </div>
      <div style={S.list}>
        {groups.map(([title, items]) => (
          <div key={title}>
            <div style={S.group}>{title}</div>
            {items.map(([id, d]) => (
              <button key={id} style={S.item} onClick={() => onPick(id)}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--accent-faint)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                <span style={S.short}>{d.short}</span>{d.name}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
  return (
    <div style={mobile ? { position: 'fixed', inset: 0, background: 'var(--overlay)', zIndex: 1000 } : S.overlay}
         onPointerDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      {body}
    </div>
  );
}
